/**
 * Выгрузка таблицы в CSV для Excel: разделитель «;», строки CRLF, BOM — чтобы
 * Excel открыл кириллицу без вопросов о кодировке.
 */
const BOM = '﻿';
/**
 * Защита от CSV-инъекции: строка, которую Excel принял бы за формулу
 * (`=`, `+`, `-`, `@`, таб, CR в начале — например, название кампании),
 * получает префикс `'`. Только строки: число (в т. ч. отрицательное) уходит
 * числом, иначе Excel не сможет с ним считать.
 */
const FORMULA_START = /^[=+\-@\t\r]/;
function cell(v) {
    if (v === null || v === undefined)
        return '';
    const s = typeof v === 'number' ? String(v).replace('.', ',') : FORMULA_START.test(v) ? `'${v}` : v;
    return /[";\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
export function toCsv(columns, rows) {
    const lines = [columns.map((c) => cell(c.header)).join(';')];
    for (const r of rows)
        lines.push(columns.map((c) => cell(c.value(r))).join(';'));
    return `${BOM}${lines.join('\r\n')}\r\n`;
}
/** Скачать CSV файлом (в браузере). */
export function downloadCsv(name, csv) {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name.endsWith('.csv') ? name : `${name}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
//# sourceMappingURL=csv.js.map